export default {
  workstation: {
    tabs: {
      workstation: "Workstation",
      trend: "Trend",
    },
    filters: {
      with: "Mit",
      without: "Ohne",
      splits: "Splits",
      none: "Keine",
    },
    sections: {
      gamelog: "Gamelog",
    },
    headers: {
      line: "Linie",
      opponent: "Gegner",
    },
    labels: {
      averagePerGame: "Durchschnitt pro Spiel",
      cover: "Cover",
    },
  },
};
